/* eslint-disable @next/next/no-img-element */

import { ClubDetailItemFragment } from '@amf/shared/types/graphql';
import { useTranslate } from '@tolgee/react';
import React from 'react';
import Container from '@amf/shared/components/layout/Container';
import Link from 'next/link';

interface ClubInfoProps {
  club: ClubDetailItemFragment;
  prefixes: { player: string };
}

function ClubInfo({ club, prefixes }: ClubInfoProps) {
  const { t } = useTranslate();
  return (
    <div className='PlayerInfo'>
      <Container className='PlayerInfo__container'>
        <div className='PlayerInfo__inner'>
          <div className='PlayerInfo__content'>
            <div className='PlayerInfo__item'>
              <i className='PlayerInfo__itemIcon bi bi-person' />
              <div className='PlayerInfo__itemContent'>
                <div className='PlayerInfo__itemTitle'>{t('club.info.playersCount')}</div>
                <div className='PlayerInfo__itemValue'>{club.currentPlayersCount}</div>
              </div>
            </div>
            <Link href={`${prefixes.player}/${club.president.id}`}>
              <a className='PlayerInfo__item'>
                {club.president.photoUrl ? (
                  <img
                    src={club.president.photoUrl}
                    alt={club.president.fullName}
                    className='PlayerInfo__itemImage'
                  />
                ) : (
                  <i className='PlayerInfo__itemIcon bi bi-person' />
                )}
                <div className='PlayerInfo__itemContent'>
                  <div className='PlayerInfo__itemTitle'>{t('club.info.president')}</div>
                  <div className='PlayerInfo__itemValue'>{club.president.fullName}</div>
                </div>
              </a>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default ClubInfo;
